import styled from '@emotion/styled';
import {
    rem,
    TableColumnAlignment,
    TableTextWrapMode,
} from '@triumph/design-system';
import { OrderedTableColumns } from '../DataTable.types';

interface StyledTableCellProps {
    value: string | number;
    columnAlignment?: TableColumnAlignment;
    textAlign: string;
    textWrapMode?: TableTextWrapMode;
}

export interface TableCellProps {
    column?: OrderedTableColumns | undefined;
    row?: any;
    value: string | number;
    textWrapMode?: TableTextWrapMode;
}

const getColumnMaxWidth = (
    columnAlignment?: TableColumnAlignment,
    textWrapMode?: TableTextWrapMode,
): string | null => {
    if (
        columnAlignment === TableColumnAlignment.Right ||
        textWrapMode === TableTextWrapMode.None
    ) {
        return null;
    }

    return rem(250);
};

export const StyledParagraphCell = styled.p`
    max-width: ${rem(252)};
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: initial;
`;

export const StyledTableCell = styled.td<StyledTableCellProps>`
    border-bottom: ${({ theme }) =>
        `${rem(1)} solid ${theme.colors.greyscale.gray15}`};
    text-align: ${({ textAlign, value }) => {
        if (textAlign) return textAlign;

        return Number.isInteger(value) ? 'end' : 'start';
    }};
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    max-width: ${({ columnAlignment, textWrapMode }) =>
        getColumnMaxWidth(columnAlignment, textWrapMode)};
    overflow-x: ${({ textWrapMode }) =>
        textWrapMode === TableTextWrapMode.Truncate ? 'hidden' : null};
    text-overflow: ${({ textWrapMode }) =>
        textWrapMode === TableTextWrapMode.Truncate ? 'ellipsis' : null};
    white-space: ${({ textWrapMode }) =>
        textWrapMode === TableTextWrapMode.Truncate ? 'nowrap' : null};
    padding: ${`${rem(12)} ${rem(8)} ${rem(4)} ${rem(8)}`};
    margin: 0;
    min-width: ${rem(35)};
    white-space: ${({ textWrapMode }) =>
        textWrapMode === TableTextWrapMode.Truncate
            ? 'nowrap'
            : 'break-spaces'};
`;
